import {OrderM} from "./order.mobel";
import {PurchaseM} from "./purchase.model";
import {BankAccountM} from "./bank_account.mobel";
import {ReceiptM} from "./receipt.model";

export class PaymentM{
  id:number =0;
  no:string = '';
  type:string = ''
  order_id:number = 0;
  order:OrderM = new OrderM();
  purchase:PurchaseM = new PurchaseM()
  receipt:ReceiptM = new ReceiptM()
  user_id:number = 0;
  store_name:string = ''
  firstname:string = '';
  lastname:string = '';
  status:string = '';
  name:string = ''
  title:string = ''
  purpose:string = 'settle_interest';
  method:string ='';
  method_title:string = '';
  bank_account:BankAccountM = new BankAccountM()
  bank:string='';
  bank_id:number = 0;
  bank_account_id:number = 0;
  bank_account_no = ""
  bank_account_name = ""
  ref_purchase_id:number = 0
  ref_purchase_no:string = ""
  price:number =0;
  transfer_date:string='';
  remark = ""
  avatar:string = '';
  admin_name = ''

  date = {day:0,month:0,year:0};
  time = {hour:0,minute:0};
  dateString:string = "";
  timeString:string = "";
  dateTimeString:string = "";
}



// WEBPACK FOOTER //
// ./src/app/model/payment.ts